export const Editor = {
  Write: 'Editor',
  Preview: 'Náhled',
  UploadingImage: 'Nahrávání obrázku',
  PasteDropSelect: 'Připojte soubory přetažením, výběrem nebo kopírováním a vložením.',
};
